// ProtectedRoute.js
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { routes } from "src/utils/constants/routes";

const ProtectedRoute = () => {
  const auth = useSelector((store) => store.auth);

  return auth?.token ? <Outlet /> : <Navigate to={routes.authSignin} replace />;
};

export default ProtectedRoute;
